<div style="margin-top: -50px">
    <div *ngIf="appService.indexData.attributes.BodyTop" [innerHTML]="this.sanitizer
.bypassSecurityTrustHtml(appService.indexData.attributes.BodyTop)"></div>
    <div class="row pb-4">
        <div *ngFor="let bi of appService.indexData.attributes.BodyImages.data" class="col-4">
            <img src="{{ appService.baseUrl + bi.attributes.url }}" alt="" class="img-fluid">
        </div>
    </div>
</div>
<section id="clients" *ngIf="appService.indexData.attributes.Clients.data" class="clients mt-4 mb-5 section-bg">
    <div class="container">
        <h2 class="main-color" i18n="@@clients">Clients</h2>
        <div class="row pb-4">
            <div *ngFor="let client of appService.indexData.attributes.Clients.data"
                class="col-lg-3 col-md-4 col-6 d-flex align-items-center justify-content-center">
                <img src="{{ appService.baseUrl + client.attributes.url }}" alt="" class="img-fluid">
            </div>
        </div>
    </div>
</section>
<section id="manufacturers" *ngIf="appService.indexData.attributes.Manufacturers.data"
    class="p-1 mt-4 mb-5 section-bg">
    <div class="container">
        <h2 class="main-color text-center py-2" i18n="@@manufacturers">Manufacturers</h2>
        <div class="row pb-4">
            <div *ngFor="let manufacturer of appService.indexData.attributes.Manufacturers.data"
                class="col-lg-3 mb-3 col-md-4 col-6 d-flex align-items-center justify-content-center">
                <img src="{{ appService.baseUrl + manufacturer.attributes.url }}" alt="" class="img-fluid">
            </div>
        </div>
    </div>
</section>


<div *ngIf="appService.indexData.attributes.BodyBottom" [innerHTML]="this.sanitizer
.bypassSecurityTrustHtml(appService.indexData.attributes.BodyBottom)">
</div>